export default __webpack_public_path__ + "static/media/report_open.e66b1154.gif";